import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { Drawer } from "@material-ui/core";
import "./sidebar.css";
import logo from "../../assets/images/logo.png";
import SidebarItem from "./SidebarItem";
import Menu from "../Menu";
import Notify from "../customHelpers/Notify";
import Catagory from "../../actions/Catagory";
import { isAuth } from "../../actions/auth";
import { API } from "../../config";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import List from "@mui/material/List";
import {
  createTheme,
  ListSubheader,
  styled,
  ThemeProvider,
} from "@mui/material";
import Loading from "../customHelpers/Loading";

const FireNav = styled(List)({
  "& .MuiListItemButton-root": {
    paddingLeft: 0,
    paddingRight: 0,
  },
  "& .MuiListItemIcon-root": {
    minWidth: 0,
    marginRight: 16,
  },
  "& .MuiSvgIcon-root": {
    fontSize: 20,
  },
});
const drawerWidth = 230;

// Routes for admin/staff users
const staff_routes = [
  {
    display_name: "Dashboard",
    route: "/admin",
    icon: "bx bxs-dashboard",
  },
  {
    display_name: "Companies",
    route: "/admin/company",
    icon: "bx bx-buildings",
  },
  {
    display_name: "Manage Requests",
    route: "/admin/requests",
    icon: "bx bx-buildings",
  },
  {
    display_name: "Manage Call Center",
    route: "/admin/callcenter",
    icon: "bx bx-phone",
  },
  {
    display_name: "Categories",
    route: "/admin/catagories",
    icon: "bx bx-category",
  },
  {
    display_name: "News",
    route: "/admin/news",
    icon: "bx bx-news",
  },
  {
    display_name: "Users",
    route: "/admin/users",
    icon: "bx bx-user-pin",
  },
  {
    display_name: "Ads",
    route: "/admin/ads",
    icon: "bx bx-notepad",
  },
  {
    display_name: "Manage Company News",
    route: "/admin/company-news",
    icon: "bx bx-news",
  },
  {
    display_name: "Manage Job Post",
    route: "/admin/jobs",
    icon: "bx bx-briefcase",
  },
  {
    display_name: "Role",
    route: "/admin/role",
    icon: "bx bx-shield-quarter",
  },
  {
    display_name: "Menus",
    route: "/admin/menus",
    icon: "bx bx-menu",
  },
];

// Routes for company users
const company_routes = [
  {
    display_name: "Dashboard",
    route: "/admin/company-dashboard",
    icon: "bx bxs-dashboard",
  },
  {
    display_name: "Company News",
    route: "/admin/all-company-news",
    icon: "bx bx-list-ul",
  },
  {
    display_name: "Company Job Posts",
    route: "/admin/all-jobs",
    icon: "bx bx-list-check",
  },
];

const callcenter_routes = [
  {
    display_name: "Search",
    route: "/",
    icon: "bx bx-phone-call",
  },
];
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: (props) => (props.open ? drawerWidth : 0),
    flexShrink: 0,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
  },
  drawerPaper: {
    width: drawerWidth,
  },
  borderR: {
    borderRight: "none",
  },
}));

const Sidebar = (props) => {
  const { open, variant, onClose } = props;
  const classes = useStyles(props);
  const { NotifyMessage } = Notify();
  const [expanded, setExpanded] = React.useState("");
  const [allowedMenus, setAllowedMenus] = useState([]);
  const [allowedMenuIds, setAllowedMenuIds] = useState([]);
  const [sidebarLoading, setSidebarLoading] = useState(true);
  const handleChangeEx = (panel) => {
    setExpanded(expanded != panel ? panel : false);
  };
  const { viewMainCatagories } = Catagory();
  const [values, setValues] = useState({
    loading: false,
    catagories: [],
  });
  const { catagories, loading } = values;

  useEffect(() => {
    getMainCatagories();
    getRoleMenus();
  }, []);

  const getRoleMenus = () => {
    const user = isAuth();
    if (!user || !user.roleId) {
      setSidebarLoading(false);
      return;
    }

    // Role 1 is Super Admin - they see everything
    if (user.roleId === 1) {
      setAllowedMenus([]); // Empty means no filter for Admin
      setSidebarLoading(false);
      return;
    }

    fetch(`${API}/role-menus/${user.roleId}`)
      .then((res) => res.json())
      .then((data) => {
        // Store full menu objects to have access to routes
        setAllowedMenus(data.data || []);
        setSidebarLoading(false);
      })
      .catch(err => {
        console.error("Error fetching role menus:", err);
        setSidebarLoading(false);
      });
  };

  const getMainCatagories = () => {
    setValues({ ...values, loading: true });
    viewMainCatagories().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.result) {
        setValues({
          catagories: data.result,
          loading: false,
        });
      } else {
        NotifyMessage({
          message: "Network timeout, try again.",
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      }
    });
  };

  // Determine which routes to show based on user role
  // For infoethiopia-dashboard-new, always show full admin menus
  let sidebar_items = callcenter_routes;
  if (props.location.pathname.includes("/admin")) {
    const user = isAuth();

    // Filter staff_routes based on allowedMenus if not admin
    if (user && user.roleId !== 1 && sidebarLoading === false) {
      sidebar_items = staff_routes.filter(item => {
        // Check if this route exists in the allowedMenus from backend
        return allowedMenus.some(m => m.route === item.route);
      });
    } else {
      sidebar_items = staff_routes;
    }
  }

  const activeItem = sidebar_items.findIndex(
    (item) => item.route === props.location.pathname
  );

  const handleLinkClick = () => {
    if (variant === "temporary") {
      onClose();
    }
  };

  return (
    <Drawer
      className={classes.drawer}
      variant={variant || "persistent"}
      anchor="left"
      open={open}
      onClose={onClose}
      classes={{
        paperAnchorDockedLeft: classes.borderR,
        paper: classes.drawerPaper,
      }}
    >
      <div className="sidebar">
        <div className="sidebar__logo">
          <img src={logo} alt="company logo" />
        </div>
        {sidebar_items.map((item, index) => (
          <Link to={item.route} key={index} onClick={handleLinkClick}>
            <SidebarItem
              title={item.display_name}
              icon={item.icon}
              key={index}
              active={index === activeItem}
            />
          </Link>
        ))}
        {
          !props.location.pathname.includes("/admin") && (
            <Box sx={{ display: "flex" }}>
              <ThemeProvider
                theme={createTheme({
                  components: {
                    MuiListItemButton: {
                      defaultProps: {
                        disableTouchRipple: true,
                      },
                    },
                  },
                  palette: {
                    mode: "dark",
                    background: { paper: "rgba(244,151,3,.8)" },
                  },
                })}
              >
                <Paper
                  elevation={0}
                  sx={{
                    width: "100%",
                    mt: 2,
                    borderRadius: "5px",
                  }}
                >
                  <Box
                    sx={{
                      pb: 0,
                    }}
                  >
                    {" "}
                    <FireNav
                      component="nav"
                      subheader={
                        <ListSubheader
                          sx={{
                            color: "white",
                            py: 1,
                            px: 3,
                            borderBottom: "1px solid rgb(20,61,89)",
                          }}
                          component="div"
                        >
                          All Categories
                        </ListSubheader>
                      }
                      sx={{
                        color: "white",
                        p: 0,
                      }}
                    >
                      {" "}
                      {loading ? (
                        <Loading color="secondary" />
                      ) : (
                        catagories.map((catagory) => (
                          <Menu
                            key={catagory.Id}
                            name={catagory.name}
                            sub={catagory.children || []}
                            Id={catagory.Id}
                            handleChangeEx={handleChangeEx}
                            expanded={expanded}
                          />
                        ))
                      )}
                    </FireNav>
                  </Box>
                </Paper>
              </ThemeProvider>
            </Box>
          )
          // (loading ? (
          //   <Loading color="secondary" />
          // ) : (
          //   // catagories.map((catagory) => (
          //   //   <Menu
          //   //     key={catagory.Id}
          //   //     name={catagory.name}
          //   //     sub={catagory.children || []}
          //   //     Id={catagory.Id}
          //   //   />
          //   // ))
          //   <Menu catagories={catagories} />
        }
      </div>
    </Drawer>
  );
};

export default Sidebar;
